module.exports = __webpack_public_path__ + "media/images/home-mobile-14dbffee96130da90a20d8593201faa0.jpg";